import React from 'react'
import { useNavigate } from 'react-router-dom'

import Button from 'Design/components/Button'

import { useListKbsQuery } from './kb.service'

const AddKbButton = () => {
  const navigate = useNavigate()

  const { isLoading, data = [] } = useListKbsQuery()

  if (isLoading || !data || data.length === 0) {
    return null
  }

  const handleClick = () => {
    navigate('import')
  }

  return (
    <Button variant='primary' onClick={handleClick}>
      Add a Knowledge Base
    </Button>
  )
}

export default AddKbButton
